import { DashboardRoutes } from "@/router";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";
import { generatePath } from "react-router-dom";

interface ChangeLogType {
  links: string[][];
  version: string;
}

// for each new release note there should be an entry inside changeLog and another one inside translation files
// changeLog contains links to changed pages
// translations contain release note texts
export const changeLog: ChangeLogType[] = [
  {
    links: [[DashboardRoutes.mySale.report.url]],
    version: "2.2.8",
  },
  {
    links: [[], [DashboardRoutes.connections.developers.tokensList.url, DashboardRoutes.connections.oauth.root.url]],
    version: "2.2.7",
  },
  {
    links: [[]],
    version: "2.2.6",
  },
  {
    links: [[]],
    version: "2.2.5",
  },
  {
    links: [[]],
    version: "2.2.4",
  },
  {
    links: [[DashboardRoutes.settings.bank.edit.url]],
    version: "2.2.2",
  },
  {
    links: [
      [DashboardRoutes.connections.developers.root.url],
      [],
      [DashboardRoutes.connections.developers.root.url, DashboardRoutes.connections.oauth.root.url],
    ],
    version: "2.2.0",
  },
  {
    links: [[generatePath(DashboardRoutes.connections.plugins.details.url, { name: "telegram" })]],
    version: "2.1.10",
  },
  {
    links: [[generatePath(DashboardRoutes.connections.plugins.details.url, { name: "slack" })]],
    version: "2.1.9",
  },
  {
    links: [[DashboardRoutes.settings.business.add.url]],
    version: "2.1.8",
  },
  {
    links: [[DashboardRoutes.myShop.bnpl.plans.root.url]],
    version: "2.1.7",
  },
  {
    links: [[DashboardRoutes.mySale.report.url]],
    version: "2.1.5",
  },
  {
    links: [[DashboardRoutes.myShop.invoice.create.url]],
    version: "2.1.4",
  },
  {
    links: [[]],
    version: "2.1.3",
  },
  {
    links: [[]],
    version: "2.1.2",
  },
  {
    links: [[], [], [DashboardRoutes.settings.business.add.url]],
    version: "2.1.0",
  },
  {
    links: [[DashboardRoutes.mySale.report.url]],
    version: "2.0.28",
  },
  {
    links: [[]],
    version: "2.0.27",
  },
  {
    links: [[]],
    version: "2.0.26",
  },
  {
    links: [[]],
    version: "2.0.25",
  },
  {
    links: [[DashboardRoutes.settings.bank.edit.url]],
    version: "2.0.24",
  },
  {
    links: [[DashboardRoutes.settings.bank.edit.url]],
    version: "2.0.23",
  },
  {
    links: [[DashboardRoutes.profile.social.url]],
    version: "2.0.22",
  },
  {
    links: [[DashboardRoutes.settings.bank.root.url]],
    version: "2.0.21",
  },
  {
    links: [[DashboardRoutes.settings.bank.root.url]],
    version: "2.0.20",
  },
  {
    links: [[DashboardRoutes.myShop.bnpl.plans.root.url]],
    version: "2.0.17",
  },
  {
    links: [[DashboardRoutes.home.overview.url]],
    version: "2.0.13",
  },
  {
    links: [[DashboardRoutes.settings.bank.root.url]],
    version: "2.0.9",
  },
  {
    links: [[DashboardRoutes.settings.shop.url]],
    version: "2.0.0",
  },
  {
    links: [[DashboardRoutes.myShop.bnpl.root.url], [DashboardRoutes.home.overview.url]],
    version: "1.19.0",
  },
  {
    links: [
      [DashboardRoutes.myShop.bnpl.root.url],
      [DashboardRoutes.user.referral.url],
      [DashboardRoutes.connections.plugins.root.url],
    ],
    version: "1.13.0",
  },
  {
    links: [[DashboardRoutes.settlement.report.list.url]],
    version: "1.10.0",
  },
  {
    links: [[]],
    version: "1.9.0",
  },
  {
    links: [[DashboardRoutes.settings.terminal.url]],
    version: "1.8.0",
  },
  {
    links: [[DashboardRoutes.user.referral.url]],
    version: "1.7.0",
  },
  {
    links: [[]],
    version: "1.6.5",
  },
  // TODO: The link have to use blog utils constant
  {
    links: [[buildUrl(URLS.BLOG_URL, "enamad").toString()]],
    version: "1.6.0",
  },
  {
    links: [[DashboardRoutes.user.upgrade.url]],
    version: "1.5.10",
  },
  {
    links: [[DashboardRoutes.home.overview.url], [DashboardRoutes.mySale.report.url]],
    version: "1.3.0",
  },
  {
    links: [[]],
    version: "1.2.0",
  },
  {
    links: [[], [], []],
    version: "1.1.0",
  },
  {
    links: [
      [DashboardRoutes.home.overview.url],
      [DashboardRoutes.connections.developers.root.url],
      [DashboardRoutes.connections.root.url],
      [],
      [],
      [],
      [DashboardRoutes.profile.root.url, DashboardRoutes.settings.root.url],
      [],
    ],
    version: "1.0.0",
  },
];
